import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  input: {
    margin: [theme.spacing(3), 0],
  },
  buttonBox: {
    display: 'flex',
    justifyContent: 'center',
  },
  button: {
    borderRadius: 4,
    fontSize: '1.3rem',
    margin: [10, 0],
    width: '100%',
    height: 'unset',
    '& svg': { height: '1.3rem', width: '1.3rem' },
    [theme.breakpoints.up('mobile')]: {
      width: 350,
    },
  },
  warning: {
    backgroundColor: theme.palette.colors.warningBackground,
  },
  warningHeader: {
    color: theme.palette.colors.red,
    letterSpacing: '0.03em',
    textTransform: 'uppercase',
  },
}));



// WEBPACK FOOTER //
// ./src/sharedComponents/MortgageSurvey/components/CashOutAmountQuestion/useStyles.js